import React from "react";
import { Box, Typography } from "@mui/material";
import "../../styles/_video.scss";

const VideoSection = () => {
  return (
    <Box className="video-section">
      <img
        className="video-bg"
        src="/images/1.png"
        alt="Param Pujya Shree Devaji Gurudev"
      />
      {/* <Box className="video-overlay">
        <Typography variant="h3" className="video-title">
          Welcome to Param Pujya Shree Devaji Gurudev
        </Typography>
      </Box> */}
    </Box>
  );
};

export default VideoSection;
